import type { PageProps } from './interfaces';

const Page = ({ children }: PageProps) => {
  return <main>{children}</main>;
};

export default Page;
